export const MosProjects: {
  id: string;
  name: string;
  link: string;
  logo: string;
  anchor?: string;
}[] = [
  {
    id: "ed",
    name: "Электронный дом",
    link: "https://ed.mos.ru/?utm_source=crowd&utm_medium=cpwidget",
    logo: require("../../../../assets/cross-promo/logos/ed.svg").default,
  },
  {
    id: "ag",
    name: "Активный гражданин",
    link: "https://ag.mos.ru/?utm_source=crowd&utm_medium=cpwidget",
    logo: require("../../../../assets/cross-promo/logos/ag.svg").default,
  },
  {
    id: "ag-kids",
    name: "Детям",
    link: "https://det.mos.ru/home?utm_source=gi&utm_medium=cpwidget",
    logo: require("../../../../assets/cross-promo/logos/ag-kids.svg").default,
  },
  {
    id: "gorod",
    name: "Наш город",
    link: "https://gorod.mos.ru/?utm_source=crowd&utm_medium=cpwidget",
    logo: require("../../../../assets/cross-promo/logos/gorod.svg").default,
  },
  {
    id: "gz",
    name: "Город заданий",
    link: "https://gz.mos.ru/?utm_source=crowd&utm_medium=cpwidget",
    logo: require("../../../../assets/cross-promo/logos/gz.svg").default,
  },
  {
    id: "ag-vmeste",
    name: "Миллион призов",
    link: "https://ag-vmeste.ru/?utm_source=crowd&utm_medium=cpwidget",
    logo: require("../../../../assets/cross-promo/logos/ag-vmeste.svg").default,
  },
  {
    id: "mos",
    name: "Портал mos.ru",
    link: "https://www.mos.ru/?utm_source=crowd&utm_medium=cpwidget",
    logo: require("../../../../assets/cross-promo/logos/mos.svg").default,
  },
  // {
  //   id: "myid",
  //   name: "Мой id",
  //   link: "https://www.mos.ru/city/projects/mosapps/?utm_source=crowd&utm_medium=cpwidget",
  //   anchor: "#myid",
  //   logo: require("../../../../assets/cross-promo/logos/myid.svg").default,
  // },
  // {
  //   id: "stories",
  //   name: "Сообщество",
  //   link: "https://stories.mos.ru?utm_source=crowd&utm_medium=cpwidget",
  //   anchor: "#stories",
  //   logo: require("../../../../assets/cross-promo/logos/stories.svg").default,
  // },
];
